import React from "react";
import StatCard from "./StatCard";
import { summarizeKPIs, MIN_SAMPLE_FOR_PCT } from "../statsAggregations";

// Four-tile overview. Applications + winners are straight counts; dollars is
// the sum of resolved award amounts (pitch.awardAmount → chapter default →
// historical $1,000). Win rate is min-N gated against total applications.
// `pitches` is the full set including manually logged awards — summarizeKPIs
// keeps them in the funded/dollars totals and out of applications/win rate.
export default function KPITiles({ pitches, chaptersByName, scopeLabel }) {
  const { totalApplications, winnerCount, applicationWinnerCount, dollarsDeployed, winRatePct } = summarizeKPIs(
    pitches,
    chaptersByName
  );

  const winRateDisplay = winRatePct == null ? "—" : `${winRatePct}%`;
  const winRateCaption =
    winRatePct == null
      ? `Needs ${MIN_SAMPLE_FOR_PCT}+ applications`
      : `${applicationWinnerCount} of ${totalApplications}`;

  const integerFormat = (n) => Math.round(n).toLocaleString();
  const dollarFormat = (n) => `$${Math.round(n).toLocaleString()}`;

  return (
    <fieldset className="win95-groupbox" style={{ marginBottom: 20, minWidth: 0 }}>
      <legend>Overview</legend>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
          gap: 8,
        }}
      >
        <StatCard
          label="Applications"
          numeric={totalApplications}
          format={integerFormat}
          value={totalApplications.toLocaleString()}
          caption={scopeLabel}
        />
        <StatCard
          label="Grants funded"
          numeric={winnerCount}
          format={integerFormat}
          value={winnerCount.toLocaleString()}
          caption={scopeLabel}
        />
        <StatCard
          label="Dollars deployed"
          numeric={dollarsDeployed}
          format={dollarFormat}
          value={dollarFormat(dollarsDeployed)}
          caption={scopeLabel}
        />
        <StatCard
          label="Win rate"
          numeric={winRatePct == null ? null : winRatePct}
          format={(n) => `${Math.round(n)}%`}
          value={winRateDisplay}
          caption={winRateCaption}
        />
      </div>
    </fieldset>
  );
}
